module.exports = __webpack_public_path__ + "static/img/head.bbe0e4af.png";